export enum ActionsMenuOptionType  {
  EDIT,
  DELETE
}
